import React from "react";
import tw from "twin.macro";


const Container = tw.div`relative  md:mx-72 my-20 border-t-2 text-center`;
const FlexContainer = tw.div`md:flex  md:px-10  md:justify-between justify-around`;
const ImageContainer = tw.div`flex justify-center my-2`;
const Card = tw.div`my-16`;


const Heading = tw.h2` md:text-2xl  font-playfair `;
const Subheading = tw.a` md:text-xs text-xs text-blue-300 cursor-pointer`;


export default () => {
    return (
        <Container>
            <FlexContainer>
                <Card>
                    <ImageContainer>
                        <img src="https://cdn-icons-png.flaticon.com/512/9460/9460649.png" width="20%" />
                    </ImageContainer>
                    <Heading>Insulation</Heading>
                    <Subheading href="/Insulation">Learn More</Subheading>
                </Card>


                <Card>
                    <ImageContainer>
                        <img src="https://cdn-icons-png.flaticon.com/512/9308/9308889.png" width="20%" />
                    </ImageContainer>
                    <Heading>Drywall</Heading>
                    <Subheading href="/Drywall">Learn More</Subheading>
                </Card>




                <Card>
                    <ImageContainer>
                        <img src="https://cdn-icons-png.flaticon.com/512/6531/6531670.png" width="20%" />
                    </ImageContainer>
                    <Heading>Mud and Tape</Heading>
                    <Subheading href="/MudTape">Learn More</Subheading>
                </Card>
                <Card>
                    <ImageContainer>
                        <img src="https://cdn-icons-png.flaticon.com/512/2400/2400595.png" width="20%" />
                    </ImageContainer>
                    <Heading>Paint</Heading>
                    <Subheading href="/Paint">Learn More</Subheading>
                </Card>


            </FlexContainer>
        </Container>
    );
};
